import classNames from "classnames";
import { Immutable } from "immer";
import React from "react";
import { t } from "ttag";

import { ConfiguratorTypes } from "../../../constants";
import { useAppDispatch, useAppSelector } from "../../../store/reducers";
import { defaults } from "../defaults";
import { setQuantity } from "../reducers";

import styles from "./index.module.scss";

type IProps = Immutable<{
    configuratorType?: ConfiguratorTypes;
}>;

export const QuantitySelector = (props: IProps): React.ReactNode => {
    const quantity = useAppSelector((rootState) => {
        const state = rootState.configurator || defaults;
        return state.ui.quantity;
    });

    const dispatch = useAppDispatch();

    const onQuantityChange = (event: React.FormEvent<HTMLSelectElement>) => {
        event.preventDefault();
        const qty = parseInt(event.currentTarget.value, 10);
        dispatch(setQuantity(qty));
    };

    const outerClasses = classNames({
        [styles.root]: true,
        "configurator__select-container": true,
        "configurator__select-container--qty": true,
        [`configurator__select-container--qty--${props.configuratorType}`]: true,
    });
    const prefixClasses = classNames({
        [styles.prefix]: true,
        "configurator__prefix": true,
        "configurator__prefix--qty": true,
        [`configurator__prefix--qty--${props.configuratorType}`]: true,
    });
    const selectClasses = classNames({
        [styles.select]: true,
        "configurator__select": true,
        "configurator__select--qty": true,
        [`configurator__select--qty--${props.configuratorType}`]: true,
    });
    const options = Array<number>(5)
        .fill(0)
        .map((_, i) => {
            return i + 1;
        })
        .map((i) => {
            return (
                <option key={i} value={i}>
                    {i}
                </option>
            );
        });
    return (
        <div className={outerClasses}>
            {/* TODO(i18n): "Qty" is an abbreviation that may not translate well - consider using full word {t`Quantity`} */}
            <label htmlFor="quantity" className={prefixClasses}>
                {t`Qty`}
            </label>
            <select
                id="quantity"
                className={selectClasses}
                value={quantity}
                onChange={onQuantityChange}
            >
                {/* TODO(i18n): "Qty" is an abbreviation that may not translate well - consider using full word {t`Quantity`} */}
                <optgroup label={t`Qty`}>{options}</optgroup>
            </select>
        </div>
    );
};
